import { usePermissionsContext } from '@/contexts/PermissionsContext'

export function usePermissions() {
    return usePermissionsContext()
}
